import { useOrderStore } from "@/stores/order";
import { loadStripe } from "@stripe/stripe-js";

export const b2kCartTokenCookieName = "b2k_cart_order_token";

export const useCartCheckoutSession = () => {
  const { setCreateOrderResponse } = useOrderStore();

  const orderTokenCookie = useCookie(b2kCartTokenCookieName);
  const cartOrderToken = orderTokenCookie.value ?? null;

  // Lazy load Stripe - only when needed, but cache the promise
  let stripePromise: Promise<any> | null = null;
  const getStripe = () => {
    if (!stripePromise) {
      stripePromise = loadStripe(String(useRuntimeConfig().public.apiStripePK));
    }
    return stripePromise;
  };

  const createOrder = async (payload: Object) => {
    try {
      const { data: response, error } = await useCreateOrder(payload);

      // Handle API errors
      if (error.value) {
        console.error("Create order API error:", error.value);
        if ((error.value as any).statusCode === 422) {
          throw error.value;
        }

        throw new Error(error.value.message || "Failed to create order");
      }

      const responseData = response.value?.data;

      if (!responseData) {
        throw new Error("No response data received from create order API");
      }

      setCreateOrderResponse(responseData);
      orderTokenCookie.value = responseData.order_token;
      return responseData;
    } catch (error) {
      // Re-throw the error so the calling code can handle it
      console.error("Error in createOrder:", error);
      throw error;
    }
  };

  const clearCartOrderTokenCookie = () => {
    orderTokenCookie.value = null;
  };

  return {
    createOrder,
    getStripe,
    clearCartOrderTokenCookie,
  };
};
